module.exports = __webpack_public_path__ + "static/img/11Market-Research.782d213d.gif";